// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planocontas_FechamentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Plano Contas Fechamento Response
 *
 * Returns all contas for a fechamento with aggregated totals.
 */
import type { Planocontas_FechamentoContaRow } from './Planocontas_FechamentoContaRow'
import type { Planocontas_FechamentoTotaisRow } from './Planocontas_FechamentoTotaisRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Planocontas_FechamentoResponseDados {
contas: Planocontas_FechamentoContaRow[]
totais: Planocontas_FechamentoTotaisRow
}

export type Planocontas_FechamentoResponse = ApiResponse<Planocontas_FechamentoResponseDados>;

registerResponseContract('Planocontas_FechamentoResponse', {
  contas: {
    type: 'array',
    required: true,
    items: {
      id:                     { type: 'number',  required: false },
      fechamento_mensal_id:   { type: 'number',  required: false },
      franquia_id:            { type: 'number',  required: false },
      categoria_id:           { type: 'number',  required: false },
      nome_conta:             { type: 'string',  required: false },
      operacao:               { type: 'string',  required: false },
      tipo:                   { type: 'string',  required: false },
      percentual_faturamento: { type: 'string',  required: false },
      valor_previsto:         { type: 'string',  required: false },
      valor_efetivo:          { type: 'string',  required: false },
      created_at:             { type: 'string',  required: false },
      updated_at:             { type: 'string',  required: false },
      variacao_percentual:    { type: 'number',  required: false },
      variance_status:        { type: 'string',  required: false },
      variance_icon:          { type: 'string',  required: false },
    },
  },
  totais: {
    type: 'object',
    required: true,
    fields: {
      total_previsto:      { type: 'number',  required: false },
      total_efetivo:       { type: 'number',  required: false },
      variacao_percentual: { type: 'number',  required: false },
    },
  },
})
